import React from 'react';
import { useNavigate } from 'react-router-dom';
import logo from "../image/bookly_logo.png";
import './LoginPortal.css';

const LoginPortal = () => {
  const navigate = useNavigate();

  return (
    <div className="d-flex flex-column justify-content-center align-items-center vh-100 portal-background">
      <div className="portal-logo-wrapper mb-4">
        <img src={logo} alt="Bookly Logo" className="portal-logo-img" />
        <h1 className="portal-brand-title">Bookly</h1>
      </div>

      <div className="portal-card-container shadow rounded p-5 text-center">
        <h3 className="mb-2 text-dark font-weight-bold">Connexion</h3>
        <p className="text-muted mb-4">Choisissez votre espace de connexion</p>

        <div className="portal-buttons-grid">
          {/* Client Card */}
          <button 
            className="portal-choice-card client-card"
            onClick={() => navigate('/ClientLogin')}
          >
            <div className="portal-card-icon">👤</div>
            <h4 className="portal-card-title">Espace Client</h4>
            <p className="portal-card-desc">
              Réservez vos spas, salons de coiffure et activités préférés.
            </p>
            <div className="portal-card-arrow">Accéder ➔</div>
          </button>

          {/* Provider Card */}
          <button 
            className="portal-choice-card provider-card"
            onClick={() => navigate('/ProviderLogin')}
          >
            <div className="portal-card-icon">💼</div>
            <h4 className="portal-card-title">Espace Prestataire</h4>
            <p className="portal-card-desc">
              Gérez votre planning, vos coupons de réduction et vos clients.
            </p>
            <div className="portal-card-arrow">Accéder ➔</div>
          </button>
        </div>

        <div className="text-center mt-4">
          <span className="text-muted small">
            Pas encore de compte ? S'inscrire en tant que{" "}
            <span 
              className="text-primary font-weight-bold cursor-pointer" 
              onClick={() => navigate('/Register')}
              style={{ cursor: 'pointer', textDecoration: 'underline' }}
            >
              Client
            </span>{" "}
            ou{" "}
            <span 
              className="text-success font-weight-bold cursor-pointer" 
              onClick={() => navigate('/ProviderRegister')}
              style={{ cursor: 'pointer', textDecoration: 'underline' }}
            >
              Prestataire
            </span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default LoginPortal;
